<mat-progress-bar
  class="progress-bar"
  [ngStyle]="{'visibility': loading ? 'visible' : 'hidden'}"
  color="primary"
  mode="indeterminate"
>
</mat-progress-bar>
<div *ngIf="loading" class="progress-bar-backdrop"></div>
